import { Box, Step, StepLabel, Stepper } from "@mui/material";

interface StepperProps {
  currentStep: number;
  steps: string[];
  handleStepClick: (index: number) => void;
  isEditMode: boolean;
}

export const StepperComponent = ({
  currentStep,
  steps,
  handleStepClick,
  isEditMode,
}: StepperProps) => (
  <Box sx={{ width: "100%", mb: 4 }}>
    <Stepper activeStep={currentStep} alternativeLabel>
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel
            onClick={() => handleStepClick(index)}
            sx={{
              cursor: isEditMode ? "pointer" : "default",
              "&:hover": {
                color: isEditMode
                  ? "primary.main"
                  : index <= currentStep
                  ? "primary.main"
                  : "inherit",
              },
            }}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  </Box>
);
